export enum ConsentWrapperStage {
  General = 'general',
  Details = 'details'
}
